import _ from 'underscore';
import Map from 'ol/Map.js';
import {defaults as defaultControls, Attribution} from 'ol/control.js';
import {Vector as VectorLayer} from 'ol/layer.js';
import VectorSource from 'ol/source/Vector.js';
import GeoJSON from 'ol/format/GeoJSON';
import LineString from 'ol/geom/LineString';
import Projection from 'ol/proj/Projection.js';
import View from 'ol/View.js';
import {getCenter} from 'ol/extent.js';

import LayerSwitcher from 'ol-ext/control/LayerSwitcher';
import '../../styles/switcher/switcher.scss';

import Floors from '../models/floor/model.js';
import DrawControl from '../models/layer/control/model.js';
import Menu from '../models/layer/menu/model.js';
import LineMenu from '../models/layer/menu/lineConfigMenu.js';
import Grid from '../models/grid/model.js';
import { target, toolbarConfig }  from './projection.js';
import Beacon from '../models/layer/menu/beacon.js';


export default class BeCoMap {

	constructor(siteData, api){
        
        
        
        this.map = null;
        this.menu;
        this.lineMenu;
        this.projection;
        this.view;
        this.vectorDrawLayer = null;
        this.vectorNodeLayer = null;
        this.vectorPolygonLayer = null;
        this.defaultControl = new DrawControl();
        this.siteData = siteData;
        this.api = api;
        this.extent = siteData.extent;
        this.imageSize = siteData.img_size;
        this.initProjection();
        this.initView();
        this.floors = new Floors(siteData['floors'],siteData['current_map'],siteData['floor_identifier'],
            this.projection,this.imageSize,this.extent);
        this.grid = new Grid(this.projection,this.imageSize,this.extent);
        this.floors.init();
    }

    initProjection(){
        this.projection = new Projection({
            code: 'xkcd-image',
            units: 'pixels',
            extent: this.extent,
            axisOrientation:'ene'
        });
    }

    initView(){
        this.view = new View({
            projection: this.projection,
            center: getCenter(this.extent),
            extent: this.extent,
            zoom: 2,
            minZoom: 2,
            maxZoom: 8
        });
    }

    // initialize plugin
    init() {
        $("#beco-container").css("background-color",this.siteData['bg_color']);
        var defaultControl = this.defaultControl;
        this.vectorDrawLayer = new VectorLayer({
            title : "Draw Layer",
            displayInLayerSwitcher: false,
            source: new VectorSource({
                features: []
            }),
            style: function(f) {
                return defaultControl.getStyle(f);
            }
        });

        this.vectorPolygonLayer = new VectorLayer({
            title : "Polygon Layer",
            displayInLayerSwitcher: false,
            opacity : 0.5,
            source: new VectorSource({
                features: []
            }),
            style: function(f) {
                return defaultControl.getAreaStyle(f);
            }
        });

        this.vectorNodeLayer = new VectorLayer({
            title : "Node Layer",
            displayInLayerSwitcher: false,
            source: new VectorSource({
                features: []
            }),
            style: function(f) {
                return defaultControl.getNodeStyle(f);
            }
        });


    
    	this.map = new Map({
                layers : this.getLayers(),
		        target: target,
		        view: this.view,
        		controls: this.showButtons(),
      	});

        
        this.map.once('rendercomplete', function(event) {
            //console.log(event);
            //console.log("rendercomplete");
        });
        if(this.siteData.write ) {
            var ctrl = new LayerSwitcher();
            this.map.addControl(ctrl);
        }
        

        this.menu = new Menu(this.map, this.api, this.siteData);
        this.lineMenu = new LineMenu();
        
        this.map.on('singleclick', function (evt) {
            console.log(evt.coordinate);

            // convert coordinate to EPSG-4326
        });

    }

    initControls(){
        this.defaultControl.addControls(Object.assign({
            layer : this.vectorDrawLayer,
            nodeLayer : this.vectorNodeLayer,
            polygonLayer : this.vectorPolygonLayer,
            map : this.map,
            menu : this.menu,
            lineMenu : this.lineMenu,
        },toolbarConfig(this.siteData['plan'])));
    }

    getLayers() {
        var tileSource = Object.assign([],[this.floors.getTileSource()]);
        tileSource.push(this.vectorDrawLayer,this.vectorNodeLayer,this.vectorPolygonLayer);
        //if(this.siteData.write ) tileSource.push(this.grid.getGridLayer());

        return tileSource;
    }

    getMapTileLabels(){
        var layerArray = this.map.getLayers().getArray();
        var mapTile = [];
        _(layerArray).each(function (layer) {
            if(layer.getProperties().displayInLayerSwitcher){
                mapTile.push(layer.getProperties());
            }
        });
        return mapTile;
    }

    showButtons() {
    	var control = defaultControls({
	        attributionOptions:  ({
	            collapsible: false
	        })
    	});
    	return control;
    }

    getMap() {
    	return this.map;
    }

    
    setData(mapData){
        let line = this.vectorDrawLayer.getSource();
        let node = this.vectorNodeLayer.getSource();
        let polygon = this.vectorPolygonLayer.getSource();
        var nodePoints = [];
        var becons = [];
        var format = new GeoJSON({
            featureProjection: this.projection,
            extractGeometryName : true
        });
        line.addFeatures(format.readFeatures(mapData.line));
        node.addFeatures(format.readFeatures(mapData.node));
        if(mapData.polygon){
            polygon.addFeatures(format.readFeatures(mapData.polygon));
        }
        _(format.readFeatures(mapData.node)).each(function (feature) { 
            if(feature.getProperties() && feature.getProperties().location){
                nodePoints.push(feature.getProperties().location.name);    
            }

            if(feature.getProperties() && feature.getProperties().beacon){
                var props = {
                    name : feature.getProperties().beacon.name,
                    major : feature.getProperties().beacon.major,
                    minor : feature.getProperties().beacon.minor,
                    uuid : feature.getProperties().beacon.uuid
                };
                
                let beacon =  new Beacon(props);
                becons.push(beacon);
            }
        });

        this.menu.setPoints(nodePoints);
        this.menu.setBeacon(becons);
    }

    getFeatures() {
        const format = new GeoJSON({featureProjection: this.projection});

        let line = this.vectorDrawLayer.getSource().getFeatures();
        let node = this.vectorNodeLayer.getSource().getFeatures();
        let polygon = this.vectorPolygonLayer.getSource().getFeatures();
        _(node).each(function(feature){
            if(feature.getProperties().geometry){
                feature.unset('undefined');
            }
        });


        
        return ({
            "line" : format.writeFeatures(line, {decimals: 10}),
            "node" : format.writeFeatures(node, {decimals: 10}),
            "polygon" : format.writeFeatures(polygon,{decimals:10}),
        });
    }

}

